
    import "src/app/AppAdmin/Billing/Actions/index.module.scss?farm_css_modules";
    
    export default {"chargesDiv": `chargesDiv-b9e93021`,"contentPage": `contentPage-b9e93021`,"topHeader": `topHeader-b9e93021`}
    